import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { EnvironmentToken } from '../../environment/enviroment-token';
import { aiValidationI18nKeyTemplate } from './ai-validation-i18n-keys';
import { I18nKeys } from './i18n-keys';

interface I18nKeysOut {
  [key: string]: string | object;
}

@Injectable({
  providedIn: 'root'
})
export class CommonsTranslationService {
  /*
  initialize i18ns with all the object keys so the compiler can catch
  new keys added to I18nKeys interface (Cards lib)
   */

  i18nKeys: I18nKeys = {
    add: '',
    address: {
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      latitude: '',
      longitude: '',
      locality: '',
      town: '',
      county: '',
      state: '',
      country: '',
      postCode: ''
    },
    addressNotFound: '',
    back: '',
    browseFiles: '',
    clickHere: '',
    closeBtn: '',
    dropToUpload: '',
    dropFilesHere: '',
    enterAddressManually: '',
    file: '',
    fileTooLarge: '',
    fileTypeNotAllowedError: '',
    isRequired: '',
    lookupAddress: '',
    next: '',
    no: '',
    noResultsFound: '',
    ok: '',
    cancel: '',
    retry: '',
    percentComplete: '',
    required: '',
    selectedAddress: '',
    start: '',
    submit: '',
    upload: '',
    uploading: '',
    uploadImage: '',
    uploadInProgress: '',
    uploadImageError: '',
    uploadTooLargeMultiple: '',
    cameraTakePhoto: '',
    cameraCancel: '',
    cameraPhotosAndFiles: '',
    cameraTorchOn: '',
    cameraTorchOff: '',
    cameraStarting: '',
    cameraTurningLightOn: '',
    cameraCapturing: '',
    viewDocument: '',
    yes: '',
    yourLocation: '',
    dataLogging: {
      label: '',
      hint: ''
    },
    video: {
      confirmDeletion: '',
      record: '',
      maximumLengthHint: '',
      recordingFailed: ''
    },
    email: {
      body: '',
      from: '',
      subject: '',
      to: ''
    },
    help: {
      label: '',
      title: '',
      submitLabel: '',
      preSubmitMessage: '',
      postSubmitMessage: '',
      invalidEmail: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      comment: ''
    },
    aiValidation: aiValidationI18nKeyTemplate()
  };

  i18ns: I18nKeysOut = {
    add: '',
    address: {
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      latitude: '',
      longitude: '',
      locality: '',
      town: '',
      county: '',
      state: '',
      country: '',
      postCode: ''
    },
    addressNotFound: '',
    back: '',
    browseFiles: '',
    clickHere: '',
    closeBtn: '',
    dropToUpload: '',
    dropFilesHere: '',
    enterAddressManually: '',
    file: '',
    fileTooLarge: '',
    fileTypeNotAllowedError: '',
    isRequired: '',
    lookupAddress: '',
    next: '',
    no: '',
    noResultsFound: '',
    ok: '',
    cancel: '',
    retry: '',
    percentComplete: '',
    required: '',
    selectedAddress: '',
    start: '',
    submit: '',
    upload: '',
    uploading: '',
    uploadImage: '',
    uploadInProgress: '',
    uploadImageError: '',
    uploadTooLargeMultiple: '',
    cameraTakePhoto: '',
    cameraCancel: '',
    cameraPhotosAndFiles: '',
    cameraTorchOn: '',
    cameraTorchOff: '',
    cameraStarting: '',
    cameraTurningLightOn: '',
    cameraCapturing: '',
    viewDocument: '',
    yes: '',
    yourLocation: '',
    video: {
      confirmDeletion: '',
      record: '',
      maximumLengthHint: '',
      recordingFailed: ''
    },
    email: {
      body: '',
      from: '',
      subject: '',
      to: ''
    },
    help: {
      label: '',
      title: '',
      submitLabel: '',
      preSubmitMessage: '',
      postSubmitMessage: '',
      invalidEmail: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      comment: ''
    },
    aiValidation: aiValidationI18nKeyTemplate()
  };

  private readonly translocoService = inject(TranslocoService);
  private readonly environment = inject(EnvironmentToken);

  loadTranslations() {
    this.i18ns = this.loadTranslationParts(this.i18ns);
    if (!this.environment.production) {
      console.log('\x1b[34m%s\x1b[0m', 'Commons translations: ', this.i18ns);
    }
    return this.i18ns as unknown as I18nKeys;
  }

  private loadTranslationParts(keys: Partial<I18nKeysOut>, path: string | null = null) {
    Object.entries(keys).forEach(([key, value]) => {
      if (typeof value === 'string') {
        keys[key] = this.translocoService.translate(path ? `_commons.${path}.${key}` : `_commons.${key}`);
      } else {
        if (!keys[key]) {
          keys[key] = {};
        }
        this.loadTranslationParts(keys[key] as object, path ? `${path}.${key}` : key);
      }
    });
    return keys as unknown as I18nKeysOut;
  }
}
